import { render, staticRenderFns } from "./CreateTaskDialog.vue?vue&type=template&id=99d98158&scoped=true&"
import script from "./CreateTaskDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskDialog.vue?vue&type=style&index=0&id=99d98158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d98158",
  null
  
)

export default component.exports